/**
 * Display-name helpers for the payout-cards surface (AUT-126). Mirrors the
 * inspectors / payouts versions — kept page-local so the cards page never
 * imports across sibling vertical boundaries.
 *
 * The cards wire carries NO inspector display name (only `inspectorId`), so
 * the avatar shows a short-id-derived monogram and the cell shows the
 * truncated id. The `view_pii`-gated `holderName` is the only PII on this
 * surface and is rendered through `<RedactedField>`, never reconstructed
 * here. Cyrillic-aware so a holder name's initials render correctly.
 */

/** Two-letter avatar initials from a display name; '#' fallback (no name). */
export const initials = (name: string | null): string => {
  if (!name) return '#';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  const first = parts[0];
  if (!first) return '#';
  const second = parts[1];
  if (!second) return first.slice(0, 2).toLocaleUpperCase();
  return ((first[0] ?? '') + (second[0] ?? '')).toLocaleUpperCase();
};

/** Truncate an id to the mockup's `insp_2b71…0e4` shape. */
export const shortId = (id: string): string => {
  if (id.length <= 11) return id;
  return `${id.slice(0, 8)}…${id.slice(-3)}`;
};
